// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: theme-american-landmark-arte -> repli-sandbox-avenew-american-landmark-arte -> oneten-royy-avenew
// Generated: 2026-10-05T19:01:14.819Z
// Counts: 0 design, 0 content, 0 slot group, 0 collection binding, 0 section, 0 style

export const designOverrides = {};

export const contentOverrides = {};

export const slotGroupOverrides = {};

export const collectionBindingOverrides = {};

export const sectionOverrides = {};

export const styleOverrides = {};
